import { render, staticRenderFns } from "./QuestionComponent.html?vue&type=template&id=18b66700&"
import script from "./QuestionComponent.vue?vue&type=script&lang=ts&"
export * from "./QuestionComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports